import dayjs from "dayjs";

export const formatDateToUTCString = (date: Date, isEndOfDay: boolean) => {
  const adjustedDate = isEndOfDay
    ? dayjs(date).set("hour", 23).set("minute", 59).set("second", 59)
    : dayjs(date).set("hour", 0).set("minute", 0).set("second", 0);
  return adjustedDate.toISOString().replace(/\.\d{3}Z$/, "");
};
